/**
 * Not yet defined in Figma. Values are MUI defaults — re-sync when design exposes z-index tokens.
 * Figma source file: https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-
 */
export const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
} as const;
